// All site content extracted from the original Nourish Natural Health Clinic website
// (Wayback Machine archive). Used as mock data for the static clone.

export const SITE = {
  name: "Nourish Natural Health Clinic",
  tagline1: "Transforming your life...",
  tagline2: "creating a healthier future",
  phone: "218.728.7010 ext. 203",
  fax: "612.235.3323",
  address1: "Located within the Duluth Hub",
  address2: "1001 E 9th St",
  address3: "Duluth, MN 55805",
  hours: [
    { day: "Tuesday", time: "9 \u2013 4 pm" },
    { day: "Wednesday", time: "9 \u2013 4 pm" },
    { day: "Thursday", time: "1 \u2013 6 pm" },
  ],
  hoursNote: "By appointment only",
  facebook:
    "https://www.facebook.com/pages/Nourish-Natural-Health-Clinic-LLC/202662879825220",
  twitter: "https://twitter.com/drmayndlac",
  instagram: "https://www.instagram.com/drshannonmay/",
};

export const NAV = [
  { label: "Welcome", path: "/" },
  { label: "Dr. Shannon May", path: "/dr-shannon" },
  {
    label: "The Medicine",
    path: "/the-medicine/philosophy",
    children: [
      { label: "Philosophy", path: "/the-medicine/philosophy" },
      { label: "Modalities", path: "/the-medicine/modalities" },
    ],
  },
  {
    label: "Services",
    path: "/services/overview",
    children: [
      { label: "Overview", path: "/services/overview" },
      { label: "Services", path: "/services/services" },
      { label: "Who We Treat", path: "/services/who-we-treat" },
    ],
  },
  {
    label: "Clinic",
    path: "/clinic/general-info",
    children: [
      { label: "General Info", path: "/clinic/general-info" },
      { label: "What to Expect", path: "/clinic/what-to-expect" },
      { label: "FAQ", path: "/clinic/faq" },
      { label: "Testimonials", path: "/clinic/testimonials" },
      { label: "Download Forms", path: "/clinic/download-forms" },
      { label: "Order Supplements", path: "/clinic/order-supplements" },
    ],
  },
  {
    label: "Resources",
    path: "/resources",
    children: [
      { label: "E-Health Letter", path: "/resources/e-health-letter" },
      { label: "Links", path: "/resources/links" },
      { label: "Recipes", path: "/resources/recipes" },
      { label: "Events/Classes", path: "/resources/events-classes" },
      { label: "Handouts", path: "/resources/handouts" },
      { label: "Articles", path: "/resources/articles" },
      { label: "Recommended Reading", path: "/resources/recommended-reading" },
      { label: "Movies", path: "/resources/movies" },
      { label: "Podcasts", path: "/resources/podcasts" },
    ],
  },
  { label: "Contact", path: "/contact" },
];

// Hero slideshow images (from original theme)
const WB = "https://web.archive.org/web/20241203181103im_";
export const HERO_IMAGES = [
  `${WB}/https://www.nourishnaturalhealth.org/wp-content/themes/nncustom/images/home1.jpg`,
  `${WB}/https://www.nourishnaturalhealth.org/wp-content/themes/nncustom/images/home1_1.jpg`,
  `${WB}/https://www.nourishnaturalhealth.org/wp-content/themes/nncustom/images/home2.jpg`,
  `${WB}/https://www.nourishnaturalhealth.org/wp-content/themes/nncustom/images/home3.jpg`,
  `${WB}/https://www.nourishnaturalhealth.org/wp-content/themes/nncustom/images/home4.jpg`,
  `${WB}/https://www.nourishnaturalhealth.org/wp-content/themes/nncustom/images/home5.jpg`,
];

export const HERO_CAPTIONS = [
  "ancient wisdom",
  "modern science",
  "individualized care",
  "natural healing",
  "whole person",
  "thrive",
];

export const PAGE_BANNERS = {
  drShannon: `${WB}/https://www.nourishnaturalhealth.org/wp-content/uploads/2011/09/banner-photo.jpg`,
  medicine: `${WB}/https://www.nourishnaturalhealth.org/wp-content/uploads/2011/09/medicine.jpg`,
  services: `${WB}/https://www.nourishnaturalhealth.org/wp-content/uploads/2011/09/services.jpg`,
  clinic: `${WB}/https://www.nourishnaturalhealth.org/wp-content/uploads/2011/09/clinic.jpg`,
  resources: `${WB}/https://www.nourishnaturalhealth.org/wp-content/uploads/2011/09/resources.jpg`,
  contact: `${WB}/https://www.nourishnaturalhealth.org/wp-content/uploads/2011/09/contact.jpg`,
};

export const HOME_BENEFITS = [
  "Rejuvenating Sleep",
  "Peaceful Mind",
  "Vibrant Energy",
  "Balanced Emotions",
  "Nourishing Relationships",
  "Graceful Aging",
  "Healthy, Thriving You",
];

export const HOME_INTRO = {
  title: "Nourish Natural Health Clinic",
  subtitle: "Helping You Live Your Best Life",
  paragraphs: [
    "Welcome to Nourish Natural Health Clinic, where your journey of thriving begins.",
    "We help you and your whole family live your best life with naturopathic primary healthcare and acupuncture. Our services are tailored to your individual needs and designed to support your body\u2019s natural balance, so you can return to\u2014and sustain\u2014optimal health and wellness.",
    "Bridging the ancient wisdom of nature with modern science, Nourish Natural Health Clinic offers the most effective healing practices for your unique needs and goals. By helping our patients thrive, we believe we are making a contribution to a more balanced and harmonious community and world.",
    "We look forward to supporting you each step of the way of your healing journey.",
  ],
  covid: {
    title: "COVID-19 Information",
    text: "Nourish Natural Health Clinic is complying with recommendations of the CDC and MDH to begin offering in-patient services again. Our plan is to ensure the health and safety of our patients and staff.",
    linkLabel: "click here",
    link: "https://web.archive.org/web/20241203181103/https://www.nourishnaturalhealth.org/wp-content/uploads/2011/09/COVID-19-Preparedness-Plan.pdf",
  },
};

export const DR_SHANNON = {
  title: "About Dr. Shannon May",
  paragraphs: [
    "Dr. Shannon May is a Naturopathic Doctor and Acupuncturist committed to empowering you and your family to achieve your health goals at each stage of life. As your teacher, healer and witness, Dr. Shannon will work with the laws of nature, your unique physiology, and your Western practitioners to help provide the most comprehensive care calibrated to address your unique needs. From the common cold to chronic disease, she addresses a full spectrum of health concerns to help you return to and maintain optimal health.",
    "Dr. May earned her Naturopathic Doctor degree and Master\u2019s of Acupuncture at the National University of Natural Medicine in Portland, OR, where she received in-depth training in: adjunctive cancer care; chronic disease; women\u2019s health; and pediatrics and primary care utilizing an integrative approach with acupuncture, herbs, homeopathics, nutrition, and lifestyle management. She is a Registered Naturopathic Doctor in the state of Minnesota.",
    "After earning a BA in International Studies from University of Minnesota Duluth (UMD), Dr. May served for 2 \u00bd years with the U.S. Peace Corps in Cameroon, Africa. It was through her work to create sustainable organic agriculture and educate families about disease prevention in this community that she deepened her passion for and commitment to living in sync with natural rhythms.",
    "Dr. May grew up on a lake in the woods near Hackensack, MN where she spent summer days eating fish from the lake and vegetables from the garden. She is thrilled to be back in the Duluth area where she can share her love of natural beauty with her patients, friends, and family.",
    "Dr. May is committed to slowing down with her family, practicing qi gong and yoga, and exploring the four seasons in all their glory. She enjoys good friends, fresh local food, and music.",
  ],
};

export const PHILOSOPHY = {
  title: "Naturopathy and Chinese Medicine",
  subtitle: "Science Meets Nature for Your Optimal Health",
  intro:
    "Nourish Natural Health Clinic offers comprehensive, holistic healthcare. Dr. Shannon May is a registered naturopathic doctor and licensed acupuncturist who draws from a wide range of modalities to address your individual health and wellness needs today and tomorrow. Following is an overview of the history, philosophy, and practice of the medicine we offer.",
  naturopathy: {
    history:
      "Naturopathic medicine began with the Nature Cure movement of the nineteenth century. Based on the belief that the human body has an innate healing ability, the earliest doctors used herbs, food, water, fasting and tissue manipulation to restore the body to health.",
    approach:
      "Today, naturopathic doctors are trained as primary care doctors that view the human body as a complex, interrelated system\u2014and therefore focus on treating the whole person. Naturopaths integrate the wisdom of nature with modern medical science to find the root cause of disharmony in the human body, and craft individualized comprehensive treatment plans to support and stimulate the body\u2019s inherent healing processes to restore it back to health.",
    education:
      "Naturopathic doctors are trained as primary care doctors for people of all ages at fully accredited naturopathic medical schools. The education includes basic sciences, conventional diagnostic and treatment methods, and natural therapeutics\u2013including healing through natural substances such as plants, minerals, water, foods and more. Naturopathic doctors are required to gain extensive clinical training through comprehensive clinical internships and substantial precept hours with other practitioners.",
    principles: [
      "First Do No Harm",
      "Identify and Treat the Cause",
      "Treat the Whole Person",
      "Use the Healing Power of Nature",
      "Doctor as Teacher",
      "Prevention is Cure",
    ],
    learnMore:
      "More information on naturopathic medicine can be found on the website of the naturopathic professional organization, the AANP (American Association of Naturopathic Physicians). Minnesota\u2019s chapter, (MNANP), provides additional information on Naturopathic licensure and other information specific to our state.",
  },
  chinese: {
    history:
      "Chinese medicine, practiced for 2,000 years, is one of the oldest medical traditions. The ancient Chinese developed this unique medical system through careful and diligent study of the body, mind, emotions, spirit, and the natural world around them.",
    philosophy:
      "This system is based on the idea that pathways of energy, or \u201cqi\u201d, run in regular patterns through the body. These channels, called meridians, flow like rivers to irrigate and nourish the body\u2019s tissues, blood and organs. An obstruction in the movement of these energy rivers is like a dam that backs up, creating imbalances and pain. Energy can also become depleted as a result of stress, overwork, or chronic illness\u2013and this may cause the energetic stream to dry up and eventually stop flowing.",
    how:
      "Chinese medicine works to restore harmony and energetic balance to the body in accordance with natural principles. A treatment may include one or more of the following modalities: herbal therapy, acupuncture, moxabustion (a heat-based stimulation of energy channels), dietary therapy, exercises in breathing and movement (tai chi and qi gong), and body work.",
  },
};

export const MODALITIES = {
  naturopathic: [
    {
      name: "Homeopathy",
      text:
        "Homeopathy is a very gentle and effective way of treating the whole person physically, mentally, and emotionally. This system and philosophy was first introduced by a German physician, Dr. Samuel Hahnemann, over 200 years ago, and is used today as mainstream medicine in many European countries, as well as India. In the practice of homeopathy, physicians use very dilute substances derived from plants, animals and minerals to address a range of acute and chronic conditions. The most fundamental principle of a homeopathic prescription is to choose a remedy that stimulates the body\u2019s own healing processes. This very individualized treatment is very safe and effective for children, and adults.",
    },
    {
      name: "Botanical Medicine",
      text:
        "Plants have been and continue to be used throughout the world as a primary means of medicine. This can be a very effective approach to helping the body return to balance if used properly. It is always important to have a trained professional assess the potential side effects or drug-herb interactions before taking botanicals as treatment.",
    },
    {
      name: "Biotherapeutic Drainage",
      text:
        "Biotherapeutic drainage is a deep acting therapy that has been used in Europe for over the past 100 years. The plant and mineral based remedies, along with lifestyle modifications, assist the body\u2019s individual systems to eliminate toxins that interfere with the body\u2019s normal physiology, thus leading to chronic disease. This in combination with other therapies provides a deeply effective way of getting to the root cause of disease to then repair and restore that physiology back into balance.",
    },
    {
      name: "Flower Essences",
      text:
        "Flower essences are created from a variety of wildflowers in a similar fashion to homeopathy. First introduced by the English physician, Dr. Edward Bach in 1930, these help eliminate disease and physical imbalances by addressing the mental/emotional state of individuals.",
    },
    {
      name: "Lifestyle Counseling",
      text:
        "It is important that all aspects of life are addressed to reach your optimal health. To achieve this goal, Dr. Shannon works with her patients in evaluating and changing patterns that may not be supporting the journey towards a healthier, more radiant you.",
    },
    {
      name: "Clinical Nutrition",
      text:
        "Nourish Natural Health Clinic believes that whole food provides deep nourishment on many levels, not only in our own health, but our community at large. This is an integral part of our individualized treatment plans to attain the most profound changes in our patients.",
    },
  ],
  chinese: [
    {
      name: "Acupuncture",
      text:
        "Used for over 2,000 years, acupuncture is one of the oldest, continually practiced forms of medicine in the world. With it being one of the most researched medical disciplines, it has become well respected by both Eastern and Western physicians. Acupuncture involves the use of sterile, non-toxic needles into the surface of the skin to stimulate particular pathways of \u201cqi\u201d, a bioelectrical force, in your body, to remove stagnation of qi and blood, which in Chinese medical theory, is viewed as the primary cause of pain and disease. Acupressure with essential oils is also another means of connecting to the \u201cqi\u201d in the body for those with a fear of needles.",
    },
    {
      name: "Moxibustion",
      text:
        "Moxibustion is a warming technique in Chinese medicine that uses the herb mugwort, or Artemesia vulgaris. This stimulates circulation and creates a smoother flow of energy and blood.",
    },
    {
      name: "Cupping",
      text:
        "Cupping is an acupressure technique that creates a vacuum by utilizing glass or plastic cups over particular acupuncture points on the skin. This promotes circulation and movement through that particular area to help relieve ailments from upper respiratory infections to musculoskeletal pain.",
    },
    {
      name: "Gua Sha",
      text:
        "Gua Sha is a massage-like technique using a smooth edge, such as a ceramic spoon, as traditional to China, with repeated pressure strokes over lubricated skin to clear out blockage and promote circulation to that muscle and tissue.",
    },
    {
      name: "Microneedling",
      text:
        "A gentle oscillating pen is used to trigger natural facial renewal while infusing natural holistic naturals into sub-epidermal layers. Good for acne, scars, wrinkles, face lift, and scalp hair growth.",
    },
    {
      name: "Nanoneedling",
      text:
        "A gentle oscillating pen is used to infuse natural topicals into top layer of skin. Good for acne, bags under eyes, and wrinkles.",
    },
    {
      name: "LED Phototherapy",
      text:
        "Use of UV free blue, red, and yellow spectral lighting to eliminate harmful bacteria & assist in facial rejuvenation.",
    },
    {
      name: "Essential Oils",
      text:
        "Essential oils are the aromatic oils extracted from particular plants, and have been used medicinally at various times in history. Therapeutically, these allow us to stimulate the limbic system by activating our senses, and further facilitate the healing process.",
    },
    {
      name: "Core Synchronism",
      text:
        "Core synchronism is a gentle energetic body work developed by Robert Stevens NTS, ND, that uses a combination of osteopathy and polarity therapy. The practitioner uses light touch to palpate the flow of cerebrospinal fluid and gently releases any restrictions felt while working on the patient. This can help improve the circulation of blood and oxygen to particular organs and tissues resulting in a reduction in pain, improved structural alignment, and a deep relaxation.",
    },
  ],
};

export const SERVICES_OVERVIEW = {
  title: "Holistic Health Care for Everyone in Your Family",
  subtitle: "Individualized Treatment at Each Stage of Life",
  body:
    "At Nourish Natural Health Clinic, we listen to your story to gain an in depth understanding of the whole picture of where you are today\u2014and where you\u2019d like to be\u2014\u2014on your healing journey. From there, we create an individualized treatment plan that integrates naturopathic and Chinese medicine philosophy and modalities. Our focus is addressing and healing not just your symptoms but the root cause of your health challenge\u2014\u2014so you can regain the vitality that is your birthright.",
};

export const SERVICES_LIST = [
  "Comprehensive naturopathic medicine and acupuncture for acute and chronic conditions",
  "Ordering of labs",
  "Unique laboratory evaluations: Comprehensive digestive analysis, adrenal function testing, male and female hormone analysis, food allergy and sensitivity testing",
  "Referrals and environmental allergy testing",
  "Pediatric care for acute and chronic conditions",
  "Offer supportive care and/or a fresh approach to many diseases that are seen as fixed or progressing",
  "Work with you and your providers to prevent and treat undesired side-effects from conventional medical treatments, while honoring you as an integrated whole",
  "Microneedling: A gentle oscillating pen is used to trigger natural facial renewal while infusing natural holistic naturals into sub-epidermal layers.",
  "Nanoneedling: A gentle oscillating pen is used to infuse natural topicals into top layer of skin.",
  "LED Phototherapy: Use of UV free blue, red, and yellow spectral lighting to eliminate harmful bacteria & assist in facial rejuvenation.",
];

export const WHO_WE_TREAT = [
  "Addiction recovery",
  "Allergies",
  "Anxiety",
  "Asthma",
  "Autoimmune disease",
  "Behavioral challenges",
  "Chronic pain",
  "Depression",
  "Detoxification",
  "Diabetes",
  "Digestive complaints",
  "Eczema",
  "Endocrine Dysfunction",
  "Fatigue",
  "Fertility",
  "Headaches",
  "Heart disease",
  "Pediatric health and wellness",
  "Preventative care",
  "Stress",
  "Teen health and wellness",
  "Wellness maintenance",
  "Women\u2019s health and wellness",
];

export const GENERAL_INFO = {
  vision: "Our Vision",
  visionLead:
    "To us, thriving, rather than surviving, is a state of wellness that allows people to live their best life.",
  visionBody:
    "We are dedicated to, and believe we are making a change in the current healthcare model by treating the root cause of disease, while fostering a more balanced and harmonious family, community and world.",
};

export const WHAT_TO_EXPECT = {
  freeConsult:
    "Dr. May offers free 15 minute consultations to prospective patients. If you are interested in meeting her and learning more about her approach before scheduling a full visit, you can start here. Call 218-728-7010 x 203 to schedule.",
  firstVisit: {
    intro:
      "Your first visit with Dr. May will focus on getting to know your story, identifying areas of concern, and truly understanding your health picture to inform a thoughtful and effective treatment plan. You can expect Dr. May to spend 1\u00bd hours with you, in which she will:",
    bullets: [
      "Take a thorough medical history and ask many clarifying questions to truly understand your current health picture and lifestyle.",
      "Perform any necessary physical exams, and may order lab work as indicated.",
      "Provide a clear treatment plan and instructions for follow-up.",
    ],
  },
  whatToBring: [
    "Your completed new patient packet. Even better, mail (with sufficient time), fax, or drop it off prior to your visit so that Dr. May has time to review your health history beforehand.",
    "Any pertinent medical records you have including recent lab or imaging reports. You can either bring these or have them sent. Download the records request form below if needed.",
  ],
  returnVisits: {
    intro:
      "You can expect Dr. May to spend 45\u201360 minutes with you on any follow-up visit, depending on the complexity of your needs. She will:",
    bullets: [
      "Assess progress",
      "Modify your treatment plan as necessary",
      "Address any new concerns.",
    ],
  },
  acute:
    "Acute visits are generally 30 minutes or less; this will vary depending on your unique needs.",
  telehealth:
    "Dr. May is available for scheduled visits by phone or TeleHealth for return patients.",
  insurance:
    "Currently, insurance companies and HMO\u2019s in Minnesota do not cover naturopathic services. Flex Spending programs may allow for naturopathic health care deductions. Check with your plan administrators. We recommend that everyone ask their insurance providers to allow coverage for natural healthcare expenses. However, insurance billing for certain lab work is possible with some insurance companies.",
  payment:
    "Payment is required at the time of service, unless previous arrangements have been made. We accept cash, check, VISA, or Mastercard for payment.",
  cancellation:
    "If you need to change or cancel your appointment, please give us at least 24 hours notice. Appointments that are either missed or cancelled with less than 24 hours notice (excluding emergencies) will be charged a $85 (New Patient Visits) and $45 (Return Visits) fee.",
  phoneEmail:
    "Dr. May is happy to answer questions regarding your current treatment plan over the phone or via e-mail. Questions requiring more than 10 minutes or not related to your current treatment plan will be charged at the regular hourly rate.",
};

export const FORMS = [
  { label: "NNHC Acute Intake Packet", file: "NNHC-Acute-Intake-Packet-12.23.pdf" },
  { label: "NNHC Adult Intake Packet", file: "NNHC-Adult-Intake-Packet-Updated-12.23.pdf" },
  { label: "NNHC Teen Intake Packet", file: "NNHC-Teen-Intake-Packet-12.23.pdf" },
  { label: "NNHC Pediatric Intake 6 \u2013 12 years", file: "NNHC-Pediatric-Intake-6-12-years-12.23.pdf" },
  { label: "NNHC Pediatric Intake Birth \u2013 5 yo", file: "NNHC-Pediatric-Intake-Birth-5-yo-12.23.pdf" },
  { label: "NNHC Records Request Form", file: "NNHC-Records-Request-Form1.pdf" },
  { label: "NNHC Microneedling Fee Schedule", file: "NNHC-MICRONEEDLING-FEE-SCHEDULE.pdf" },
  { label: "NNHC Microneedling Informed Consent Form", file: "NNHC-Microneedling-Informed-Consent-Form.docx" },
  { label: "NNHC Microneedling Intake Form", file: "NNHC-Microneedling-Intake-Form.docx" },
];

export const FAQ_NATUROPATHIC = [
  {
    q: "What is a Naturopathic doctor?",
    a: "Naturopathic doctors are trained with an emphasis on holistic assessment and treatment that focuses on the vitality and wellbeing of the whole person. Our goal is to stimulate the body\u2019s power to heal itself. Rather than suppress symptoms, the aim is to search out and treat the cause of disease, so as to best prevent recurrence and optimize health.",
  },
  {
    q: "What type of training does a Naturopathic doctor receive?",
    a: "Naturopathic Doctors receive 4\u20135 years of rigorous medical training (3500 classroom hours) at accredited Naturopathic Medical Schools, including a comprehensive clinical internship (1200 hours), and substantial precept requirements (300 hours). Naturopathic doctors are comprehensively trained in holistic assessment and treatment modalities including botanical medicine, nutrition, hydrotherapy, physical manipulation, homeopathy, and minor surgery. In addition, they are extensively trained in modern diagnostic techniques, and have a thorough understanding of western medical interventions and pharmacology.",
  },
  {
    q: "How are naturopathic and conventional doctors similar and/or different from one another?",
    a: "Naturopathic doctors are trained at an accredited four-year naturopathic medical school in clinical, physical, and laboratory diagnosis. Primarily, naturopathic and allopathic medicines differ in philosophy and in treatment. Both are trained to diagnose and treat disease. Naturopathic medicine embraces a whole body philosophy that examines a person\u2019s entire picture, understanding that any condition is more than the sum of its presenting symptoms. An ND will aim to uncover the cause of the disharmony rather than just trying to eliminate symptoms.",
  },
  {
    q: "What can I expect from my first and subsequent visits?",
    a: "An initial office visit with us will usually last up to one and a half hours. The office visit consists of a complete health history and pertinent physical exams. We can expect that your journey towards health and wellness will occur in stages. So from the beginning we create a clear plan and vision of your health goals and how we will achieve them.",
  },
  {
    q: "How often will I be treated?",
    a: "Dr. May believes in establishing a dynamic relationship with each of her patients. Each patient is unique, as is his or her journey towards health. She tailors a plan to each individual and therefore healing takes a different amount of time for each person. In cases of chronic illness, it may be required to come in for treatment on a regular basis. In more acute situations, follow-up may be required in a matter of days.",
  },
  {
    q: "Does Dr May order labs?",
    a: "This will depend on your individual needs. If you have already had previous lab work done please bring a copy with you to your first visit with us. In addition to a set of basic blood work that you may or may not need, we might request tests that are more specific and provide other types of information. Some examples of these tests include food intolerance testing, a Gastro-Intestinal Health Panel, an Adrenal Stress Index, and others.",
  },
  {
    q: "Can Dr May help my children?",
    a: "Having worked with children in the past, Dr. May has a wonderful way with children. She approaches them on their level and strives to help them feel comfortable and safe. There are toys in the office for many ages and all of her pediatric patients know where they are and look forward to visiting the office. Dr. May has experience with infants and children of all ages.",
  },
  {
    q: "Will you work with my other healthcare providers?",
    a: "Absolutely. She believes that a treatment team is the best way to support her patients. Naturopathic medicine works well in conjunction with conventional care; in fact, it often helps improve the results and reduce the side-effects of treatments you are receiving.",
  },
  {
    q: "If I\u2019m taking prescription medications can I take natural medicines?",
    a: "Yes, depending upon circumstances. Dr. May has been trained extensively in the interactions of pharmaceutical medications and herbal medicine. This training includes the potentially adverse effects that may occur if improperly combined. She will avoid harmful combinations of both drug-nutrient interactions and drug-herbal interactions.",
  },
  {
    q: "Can Naturopathic Doctors prescribe medications?",
    a: "Current Minnesota law disallows ND\u2019s from prescribing pharmaceutical medications, so a referral would be made if Dr. May believed that to be the most efficacious treatment for your condition. Dr. May is fully trained in pharmacology, and has had experience with prescription medications in Oregon State.",
  },
  {
    q: "Can a Naturopathic Doctor help me to get off my current medications?",
    a: "Only the doctor that prescribed a pharmaceutical medication has the ability to discontinue its use. Abrupt discontinuation of a drug is often dangerous, and is never advised. It may be possible to increase your health using Naturopathic treatments to the point where the medication may be safely reduced or even eliminated.",
  },
  {
    q: "Will insurance cover my appointment?",
    a: "Currently, insurance companies and HMO\u2019s in Minnesota do not cover naturopathic services. Flex Spending programs may allow for naturopathic health care deductions. Check with your plan administrators. However, insurance billing for certain lab work is possible with some insurance companies.",
  },
  {
    q: "What methods of payment are accepted?",
    a: "Our office accepts cash, checks, Visa, and Mastercard. If you have any more questions concerning our payment policies, please contact our office directly.",
  },
  {
    q: "Does Dr May do phone or Skype consults?",
    a: "Dr. May is available for scheduled visits by phone or Skype for return patients.",
  },
  {
    q: "I\u2019ve never seen a Naturopathic doctor, so how do I know if it\u2019s right for me?",
    a: "Dr. May offers a free 15-minute consultation \u2013 aimed at seeing if this is a good fit for you both personally and professionally. Give us a call to set up a consultation.",
  },
  {
    q: "What conditions can be treated with naturopathic medicine?",
    a: "Dr. May treats both acute and chronic diseases. Trained as a general practitioner, she treats the full range of health concerns from acute upper respiratory infections to chronic disease. Dr. May has special interest in gastrointestinal, endocrine, auto-immune, neurological, pediatrics, and women\u2019s health conditions, but is open to treating just about any condition.",
  },
  {
    q: "What is the patient\u2019s role in treatment?",
    a: "Dr. May believes in the importance of each individual taking responsibility for his/her own health. As a society we have fallen into the role of passive acceptors of health care. Dr. May would like to return the notion of accountability to health. She does not claim to heal anyone. Rather, she gathers and makes use of appropriate resources to support individuals in healing themselves.",
  },
  {
    q: "Should I come to you for overall wellness or only if I have a medical problem?",
    a: "It is customary in our culture to only go to see the doctor if you are feeling sick. Imagine a model instead that is truly based on preventative medicine, where the focus is not on the lack of disease, but instead on the optimization of wellness. A focus on wellness dramatically decreases the abilities of disease to fully take hold on our bodies.",
  },
];

export const FAQ_CHINESE = [
  {
    q: "What is Chinese medicine?",
    a: "Chinese medicine is based on the idea that pathways of energy, or \u201cqi\u201d, run in regular patterns through the body and over its surface. These channels are called meridians and they flow like rivers through the body to irrigate and nourish the tissues. An obstruction in the movement of these energy rivers is like a dam that backs up, creating imbalance and pain. Acupuncture works with the body\u2019s innate ability to heal itself; once pathways have been unblocked, the body\u2019s natural healing response can take place.",
  },
  {
    q: "How is Acupuncture used?",
    a: "Acupuncture is an Asian healing technique that has addressed physical, emotional, and spiritual ailments since ancient times. By inserting thin, virtually painless pins into specific points on the body, acupuncture stimulates the body\u2019s innate ability to balance itself and recover from illness. Acupuncture has improved the following conditions, and many more: chronic and acute pain; depression and anxiety; auto-immune diseases; high blood pressure; allergies and asthma; and women\u2019s issues at all stages of life.",
  },
  {
    q: "What does Acupuncture feel like? Does it hurt?",
    a: "Because every person is made up of such a complex array of life experiences, it is no wonder that people feel and respond to needling in very different ways. The typical description includes feeling a slight pinch or pressure, which is then accompanied by warmth, tingling, or a heavy sensation at the site of the needle. Many people experience a deep sense of release and relaxation during and at the end of the treatment.",
  },
  {
    q: "Is Acupuncture safe?",
    a: "The needles are all sterile, pre-packaged and used one time only. The needles are hair-fine, with a solid center unlike the hollow hypodermic needles used to take blood. There is usually no marking on the skin after the needles are removed.",
  },
  {
    q: "What should I expect from my first acupuncture visit?",
    a: "The first treatment is Dr. May\u2019s opportunity to get to know you better; She will complete a detailed intake in order to learn more about your symptoms and how they may be interrelated. Even the smallest detail may shed light on the root cause of your condition.",
  },
  {
    q: "How often will I have to come in for treatment?",
    a: "Quantity of care depends entirely on the case of each patient, the severity of the illness, previous medical history, age, etc. In cases of chronic illness, it may be required to come in for treatment on a regular basis. In more acute situations, follow-up may be required in a matter of days.",
  },
  {
    q: "If I have a fear of needles, can I still receive Chinese medicine treatments?",
    a: "Dr. May is also extensively trained in the use of Essential Oils and Chinese medicine as well as flower essences, homeopathy and moxibustion [Chinese medicine technique] for the treatment of many conditions. Acupuncture needles are not always used although acupuncture points are often used.",
  },
  {
    q: "What conditions can be treated with Chinese medicine?",
    a: "Chinese Medicine practitioners are suited to treat nearly all manner of acute and chronic conditions \u2013 from colds and flus to autoimmune conditions and issues with digestion, circulation, menstruation, fertility, allergies/sinuses, chronic pain conditions and beyond \u2013 in a manner that is consistent with the constitution of the individual.",
  },
];

export const TESTIMONIALS = [
  {
    initials: "A.H.P.",
    text:
      "I had no idea how much Dr. May would impact my health the first time I went in to see her. I went into the clinic more or less out of desperation, due to chronic colds that never seemed to go away. I knew my regular doctor would just say to get more rest and take Vitamin C, which was NOT working (or really possible, with 2 toddlers at home). For about a year and a half I had a cold almost constantly, and was miserable. Every family video we took for a long time had me coughing in the background. Dr. May put me on a probiotic, and I haven\u2019t been sick in a year (except when I missed a dose). It was just that simple. She figured out that during my second pregnancy, when I got food poisoning (twice), my gut bacteria got all messed up, which affected my immune system. In addition, her acupuncture was the only thing that alleviated my all-day morning sickness. I would recommend Dr. May to anyone. She is a fantastic listener, uses sound science principles to determine treatments, and actually generates REAL RESULTS. I was foolish to go to a naturopath as a last resort \u2013 if I had seen her right when I started having problems, I could have saved myself a year and a half of misery.",
  },
  {
    initials: "S.L.",
    text:
      "Shannon is THE most awesome naturopath doctor. She was a major help in my final weeks of my twin pregnancy. If you know anything about PUPPS rash in pregnancy\u2026you can imagine how thrilled I was when Shannon cured it for me. Dr. May is a true miracle worker.",
  },
  {
    initials: "A.R.",
    text:
      "For about two years I struggled with a progressively worsening reaction. In years past I struggled with eczema but this was different. I would have a quick onset, on my face, of itching and redness, followed by days of mild swelling and sloughing. I sought help from my primary physician, a dermatologist, and an allergist; I was treated but the problem was never solved. I was positive there was something causing the reaction, so I turned to someone new. On my first visit to Dr. May she explained she felt it was food related and that not all reactions are immediate. She ordered a test which pinpointed the foods that my body definitely did not like but took a day or two to react. After avoiding them and following a cleansing advised by Dr. May, it started to clear up in about 2 months. At 5 months it is drastically improved. This started in my mid 40\u2019s and I was very surprised to learn about which foods were irritants \u2013 foods I\u2019ve always eaten. I am very happy and thankful for Dr. May\u2019s help. Her knowledge and perspective is so refreshing.",
  },
  {
    initials: "D.B.",
    text:
      "Finding Dr. May at a time when I had unexpected health challenges has changed my life and lifestyle in a very positive way! At the initial visit, she learned everything about me so I am treated as a whole person. Her relaxed and comforting manner has taken away many of the fears I had felt in the past. Dr. May helps me deal with my traditional doctors using medical test results and \u2018walks beside me\u2019 as I face treatments by explaining western medicine and making recommendations. Knowing me, as a whole person, she has suggested supplements and acupuncture and I am stronger and happier than before we met! It is hard to put into words the comfort I have felt as I have walked the pathway of the \u2018unknown\u2019 with Dr. May as my advocate and friend.",
  },
];

export const LINKS_SECTIONS = [
  {
    title: "Naturopathic Medical Professional Organizations in North America",
    items: [
      { label: "American Association of Naturopathic Physicians", url: "http://www.naturopathic.org/" },
      { label: "Canadian Association of Naturopathic Doctors", url: "http://www.naturopathicassoc.ca/" },
      { label: "Association of Accredited Naturopathic Medical Colleges", url: "http://www.aanmc.org/" },
      { label: "Oregon Association of Naturopathic Physicians", url: "http://www.oanp.org/" },
      { label: "USDE Accreditation Site", url: "http://www2.ed.gov/admins/finaid/accred/index.html" },
      { label: "Helfgott Research Institute \u2013 Natural Medicine Research", url: "http://www.ncnm.edu/helfgott-research/about-helfgott.php" },
      { label: "Minnesota Association of Naturopathic Physicians", url: "http://www.mnanp.org/" },
      { label: "Wisconsin Naturopathic Doctors Association", url: "http://www.wisconsin-nd.org/" },
    ],
  },
  {
    title: "Naturopathic Medical Schools",
    items: [
      { label: "National College of Natural Medicine, Oregon", url: "http://www.ncnm.edu/" },
      { label: "Bastyr University, Washington", url: "http://www.bastyr.edu/" },
      { label: "Southwest College of Naturopathic Medicine & Health Sciences, Arizona", url: "http://www.scnm.edu/" },
      { label: "University of Bridgeport College of Naturopathic Medicine, Connecticut", url: "http://www.bridgeport.edu/" },
      { label: "Canadian College of Naturopathic Medicine, Ontario", url: "http://www.ccnm.edu/" },
      { label: "Boucher Institute of Naturopathic Medicine, British Columbia", url: "http://www.binm.org/" },
    ],
  },
  {
    title: "Food",
    items: [
      { label: "Whole Foods Coop \u2013 Duluth", url: "http://www.ashlandfood.coop/" },
      { label: "Nourish This \u2013 A Fresh Take on Eating Healthy", url: "http://www.nourishthis.com/" },
      { label: "Recipe RX \u2013 Customize recipes for your personal needs", url: "http://www.reciperx.com/welcome" },
      { label: "Cookus Interruptus \u2013 How to cook healthy food despite life\u2019s interruptions", url: "http://www.cookusinterruptus.com/" },
      { label: "Super Natural Recipe Search", url: "http://www.supernaturalrecipes.com/" },
      { label: "Safe, Healthy, Grass Fed meats", url: "http://www.eatwild.com/" },
      { label: "Find the Healthiest & Safest Seafood", url: "http://www.edf.org/page.cfm?tagID=1521" },
      { label: "Information on Mercury in Seafood", url: "http://www.nrdc.org/health/effects/mercury/index.asp" },
    ],
  },
  {
    title: "Gluten-Free Resources",
    items: [
      { label: "Gluten Free Goddess", url: "http://glutenfreegoddess.blogspot.com/" },
      { label: "Gluten-Free Doctor Recipes", url: "http://www.gfdoctorrecipes.com/" },
      { label: "Gluten-Free Girl", url: "http://glutenfreegirl.com/" },
      { label: "RecipeZaar Gluten-free recipes", url: "http://www.food.com/recipes/gluten-free" },
      { label: "Celiac & Gluten free information", url: "http://www.celiac.com/" },
      { label: "GlutenFree.com", url: "http://www.glutenfree.com/" },
      { label: "Gluten Free Tastefully", url: "http://www.glutenfreetastefully.com/" },
    ],
  },
  {
    title: "Sustainable Living",
    items: [
      { label: "Cool People Care", url: "http://coolpeoplecare.org/" },
      { label: "Green Maps Around the World", url: "http://www.greenmap.org/" },
      { label: "How to Recycle Anything", url: "https://www.realsimple.com/home-organizing/organizing/tips-techniques/recycle-anything-00000000006117" },
      { label: "Ode Magazine", url: "http://www.odemagazine.com/" },
    ],
  },
  {
    title: "Environment and Health",
    items: [
      { label: "Environmental Working Group", url: "http://www.ewg.org/" },
      { label: "Environmental Health Watch", url: "http://www.ehw.org/" },
      { label: "NAB: Pollen and Mold Counts", url: "http://www.aaaai.org/" },
      { label: "EPA Toxic Releases Database", url: "http://www.epa.gov/tri/" },
      { label: "For Conscientious Oregon Parents", url: "http://www.oeconline.org/our-work/kidshealth" },
    ],
  },
];

export const HANDOUTS = [
  { label: "Bieler Broth Recipe Handout", file: "Bieler-Broth.docx" },
  { label: "Castor Oil Pack Handout", file: "NNHC-Castor-oil-pack-instructions.docx" },
  { label: "Wet Sock Treatment Handout", file: "Wet-Sock-Tx.docx" },
];

export const RECOMMENDED_READING = [
  {
    section: "Food & Nutrition",
    items: [
      "Breaking the Vicious Cycle: Intestinal health through diet \u2014 Elaine Gottschall, MSc",
      "Coping with Food Intolerances \u2014 Dickson Thom, DDS, ND",
      "Fats That Heal, Fats That Kill \u2014 Udo Erasmus",
      "Feeding the Whole Family \u2014 Cynthia Lair",
      "The Gluten Connection \u2014 Shari Lieberman, PhD",
      "Healing With Whole Foods \u2014 Paul Pitchford",
      "In Defense of Food: An Eater\u2019s Manifesto \u2014 Michael Pollan",
      "The Mediterranean Diet \u2014 Marissa Cloutier, MS, RD & Eve Adamson",
      "The Okinawa Program \u2014 Bradley J. Willcox, MD, D. Craig Willcox, PhD, & Makoto Suzuki, MD",
      "The Omnivore\u2019s Dilemma: A Natural History of Four Meals \u2014 Michael Pollan",
      "One Bowl: A Guide to Eating For Body and Spirit \u2014 Don Gerrard",
      "The Splendid Grain \u2014 Rebecca Wood",
      "Staying Healthy With Nutrition (21st Century Edition) \u2014 Elson M. Haas, MD & Buck Levin, PhD, RD",
      "Wholefood: Heal, Nourish, Delight \u2014 Jude Blereau",
    ],
  },
  {
    section: "Cookbooks",
    items: [
      "The Anti-Inflammation Diet and Recipe Book \u2014 Jessica Black, ND",
      "The Cleanse Companion Cookbook \u2014 Bonnie Nedrow, ND and Chef Jeff Hauptman",
      "The Complete Food Allergy Cookbook \u2014 Marilyn Gioannini",
      "Cooking Under Pressure \u2014 Lorna J. Sass",
      "Feeding the Whole Family: Cooking with Whole Foods \u2014 Cynthia Lair",
      "Nourishing Traditions \u2014 Sally Fallon",
      "Raw for Dessert \u2014 Jennifer Cornbleet",
      "The Whole Foods Allergy Cookbook \u2014 Cybele Pascal",
      "The Whole Life Nutrition Cookbook \u2014 Alissa Segersten and Tom Malterre",
    ],
  },
  {
    section: "Gluten-Free Cookbooks",
    items: [
      "1,000 Gluten-Free Recipes \u2014 Carol Fenster",
      "Gluten-Free Baking Classics \u2014 Annalise Roberts",
      "The Eat Well Cookbook: Gluten-Free and Dairy-Free Recipes for Food Lovers \u2014 Jan Purser & Kathy Snowball",
    ],
  },
  {
    section: "Women\u2019s Health",
    items: [
      "Birthing from Within \u2014 Pam England, CNM, MA & Rob Horowitz, PhD",
      "From the Hips \u2014 Rebecca Odes",
      "Healthy Parents, Better Babies \u2014 Naish & Roberts",
      "Ina May\u2019s Guide to Childbirth \u2014 Ina May Gaskin",
      "The Infertility Cure \u2014 Randine Lewis, LAc",
      "Natural Fertility \u2014 Naish",
      "The Natural Way to Better Babies \u2014 Naish & Roberts",
      "Taking Charge of Your Fertility \u2014 Toni Weschler, MPH",
      "Women\u2019s Bodies, Women\u2019s Wisdom \u2014 Christianne Northrup, MD",
      "Women\u2019s Encyclopedia of Natural Medicine \u2014 Tori Hudson, ND",
    ],
  },
  {
    section: "Children\u2019s Health",
    items: [
      "A Mind At A Time \u2014 Mel Levine",
      "Children with Starving Brains \u2014 Jaquelyn McCandless, MD",
      "How to talk so your kids will listen and listen so your kids will talk \u2014 Adele Faber",
      "Last Child in the Woods \u2014 Richard Louv",
      "Our Babies, Ourselves \u2014 Meredith Small",
      "The Out-of-Sync Child \u2014 Carol Stock Kranowitz, MA",
      "Positive Discipline \u2014 Jane Nelsen Ed.D",
      "The Vaccine Guide \u2014 Randall Neustaedter, OMD",
      "What Your Doctor May Not Tell You About Children\u2019s Vaccines \u2014 Stephanie Cave, MD",
      "Your Child\u2019s Growing Mind \u2014 Jane M. Healy, PhD",
    ],
  },
  {
    section: "Sustainable Lifestyle",
    items: [
      "Simple Prosperity: Finding Real Wealth in a Sustainable Lifestyle \u2014 David Wann",
      "Stuff: The Secret Lives of Everyday Things \u2014 John C. Ryan & Alan Thein Durning",
    ],
  },
];
